import Cookies from 'js-cookie';
import { isBuildIn } from '../build-in';
import { useFinalValue } from './react-utils';
import { getCurrentLanguage, Language, LanguageKey } from '../language';
export { adaptLanguage, getCurrentLanguage, Language, LanguageKey } from '../language';

export const LanguageList = [
  {
    title: 'English',
    value: Language.en,
  },
  {
    title: 'Deutsch',
    value: Language.de,
  },
  {
    title: '日本語',
    value: Language.ja,
  },
  {
    title: 'Español',
    value: Language.es,
  },
  {
    title: 'Русский',
    value: Language.ru,
  },
  {
    title: '繁體中文',
    value: Language.zhHant,
  },
  {
    title: '简体中文',
    value: Language.zhHans,
  },
];

export const useLanguage = () => {
  const currentLanguage = useFinalValue(() => {
    const lng = getCurrentLanguage();
    const defaultLng = isBuildIn() ? Language.en : Language.zhHans;
    return (
      LanguageList.find((i) => i.value === lng) || LanguageList.find((i) => i.value === defaultLng)!
    );
  });

  const changeLanguage = (value: string) => {
    Cookies.set(LanguageKey, value, {
      expires: new Date(new Date().getTime() + 365 * 24 * 60 * 60 * 1000),
      path: '/',
    });
  };

  return { currentLanguage, changeLanguage };
};
